import React, { memo, useState } from 'react';
import { IconInfo, IconValidationInvalid, PhoneNumberInput, } from '@adc/parallax-component-library';
import InfoBottomSheetModal from './InfoBottomSheetModal';
const PhoneInput = memo(({ isInvalid = false, label = '', errorMessage, placeholder = '', value, onBlur, onChangeText, disabled, testID, inputMode, onFocus, maxLength, }) => {
    const showErrorMessage = isInvalid && errorMessage;
    const [isOpen, setIsOpen] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(InfoBottomSheetModal, { isOpen: isOpen, setIsOpen: setIsOpen }),
        React.createElement(PhoneNumberInput, { inputMode: inputMode, "aria-label": label, label: label, placeholder: placeholder, onFocus: onFocus, onBlur: onBlur, error: isInvalid, supportingText: showErrorMessage ? errorMessage : undefined, onChangeText: onChangeText, value: value, testID: testID, disabled: disabled, maxLength: maxLength, 
            // @ts-expect-error TODO: wait for a new parallax version
            inlineIconConfig: {
                icon: React.createElement(IconInfo, null),
                'aria-label': 'icon',
                onPress: () => {
                    setIsOpen(true);
                },
                color: '$interactive.core.enabled',
                disabledColor: '$interactive.core.disabled',
            }, supportingIconConfig: showErrorMessage
                ? {
                    icon: React.createElement(IconValidationInvalid, { testID: `${testID}-icon` }),
                    color: '$support.danger.surfaceOnColorAlt',
                }
                : undefined })));
});
PhoneInput.displayName = 'PhoneInput';
export { PhoneInput };
